import {CHANGE_LANGUAGE_DEFAULT} from "../constants/action";

export const changeLanguageDefault = (language) => (dispatch) => {
      return dispatch({
            type: CHANGE_LANGUAGE_DEFAULT,
            payload: language
      })
}